import Alpine from 'alpinejs';

document.addEventListener('alpine:init', () => {
  Alpine.data('initContentBlock', () => {
    return {
      moreContent: false,
      showBtn: false,
      totalContent: false,
      init() {
        const content = this.$refs.clamp.offsetHeight;
        if (content <= 204) {
          this.moreContent = false;
          this.showBtn = false;
        } else {
          this.moreContent = true;
          this.showBtn = true;
          this.totalContent = false;
        }
      }
    }
  });
});
